import { SelectableOptionItem } from '@bonanza-social/navigation';

export const PROVINCES: SelectableOptionItem[] = [
  { text: 'Alberta', dynamicValues: { code: 'AB' } },
  { text: 'British Columbia', dynamicValues: { code: 'BC' } },
  { text: 'Manitoba', dynamicValues: { code: 'MB' } },
  { text: 'New Brunswick', dynamicValues: { code: 'NB' } },
  { text: 'Newfoundland and Labrador', dynamicValues: { code: 'NL' } },
  { text: 'Northwest Territories', dynamicValues: { code: 'NT' } },
  { text: 'Nova Scotia', dynamicValues: { code: 'NS' } },
  { text: 'Nunavut', dynamicValues: { code: 'NU' } },
  { text: 'Ontario', dynamicValues: { code: 'ON' } },
  { text: 'Prince Edward Island', dynamicValues: { code: 'PE' } },
  { text: 'Quebec', dynamicValues: { code: 'QC' } },
  { text: 'Saskatchewan', dynamicValues: { code: 'SK' } },
  { text: 'Yukon', dynamicValues: { code: 'YT' } },
];
